// extracted by mini-css-extract-plugin
module.exports = {"group":"Group_group__phboa"};